<template>
    <div class="multi-switch-item">
        <input
            class="radio-input"
            :id="groupName + '-' + value"
            v-bind="$attrs"
            type="radio"
            :value="value"
            :checked="active"
            :name="groupName"
            style="opacity: 0;"
        />
        <label
            :for="groupName + '-' + value"
            class="btn btn-primary radio-button container-xs"
        >
            {{ title }}
        </label>
    </div>
</template>

<script>
export default {
    name: "DdMultiSwitchItem",
    props: {
        active: {
          type: Boolean,
          required: false,
          default: false
        },
        title: {
          type: String,
          required: false
        },
        value: {
          type: [String, Number],
          required: false
        },
    },
    inject: ['groupName'],
}
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";
label{
    background-color: $color-white;
}
div:first-child:not(:last-child) > label{
    border-bottom-right-radius: 0 !important;
    border-top-right-radius: 0 !important;
}
div:last-child:not(:first-child) > label{
    border-bottom-left-radius: 0 !important;
    border-top-left-radius: 0 !important;
}
div:not(:first-child):not(:last-child) > label{
    border-radius: 0;
}
.multi-switch-item > label {
  border-left: 0 solid transparent;
}
.multi-switch-item:first-of-type > label {
  border-left: 1px solid $brand-primary;
}
input:checked + label{
    background-color: $brand-primary;
    color: $color-white !important;
}
</style>
